export default __webpack_public_path__ + "static/media/thp-site.b3479acc.png";